<template>
  <div>
    <div>
      <div class="score-title">
        <el-tooltip
          :content="$t('rate_explained_by_reputation_of_page')"
          placement="top"
        >
          <el-progress
            class="progress-dashboard"
            type="dashboard"
            :stroke-width="10"
            :percentage="data.netlinkingDetails[1].score"
            :format="format"
            :color="customColor"
          >
          </el-progress>
        </el-tooltip>
        <h3>{{ $t("netlinking_of_my_page") }}</h3>
      </div>
      <div>
        <div class="flex-box">
          <referring-domains-graph
            v-if="data"
            class="small-graph"
            :data="data.urlsMetrics"
          >
          </referring-domains-graph>
          <div class="divider">
            <el-divider
              direction="vertical"
              class="vertical"
            />
          </div>
          <backlinks-distribution-graph
            v-if="data"
            class="big-graph"
            url-or-domain="URL"
            :data="data.urlsBacklinksDistribution"
          >
          </backlinks-distribution-graph>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BacklinksDistributionGraph from "@/pages/ActionPlan/Netlinking/Shared/BacklinksDistributionGraph";
import ReferringDomainsGraph from "@/pages/ActionPlan/Netlinking/Url/ReferringDomainsGraph";

export default {
  components: {
    BacklinksDistributionGraph,
    ReferringDomainsGraph,
  },
  props: {
    data: Object,
    keyword: Object,
    page: Object,
    currentUser: Object,
  },
  methods: {
    format(percentage) {
      return percentage;
    },
    customColor(percentage) {
      if (percentage < 25) {
        return "#f56c6c";
      } else if (percentage < 50) {
        return "#e6a23c";
      } else if (percentage < 75) {
        return "#1989fa";
      } else {
        return "#67c23a";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.score-title {
  margin-bottom: 1.5rem;
  display: flex;
  flex-direction: row;
  align-items: baseline;

  .progress-dashboard {
    margin-right: 1.4rem;

    ::v-deep .el-progress__text {
      font-size: 1.25rem !important;
    }

    ::v-deep .el-progress-circle {
      height: 90px !important;
      width: 90px !important;
    }
  }
}

.flex-box {
  display: flex;
  flex-direction: row;
  width: 100%;

  .small-graph {
    flex-basis: 30%;
  }

  .big-graph {
    flex-basis: 70%;
  }

  .divider {
    margin: 0px 8px 0px 8px;

    .vertical {
      height: 100%;
    }
  }
}
</style>

<i18n>
{
  "en": {
    "netlinking_of_my_page": "Your page netlinking",
    "rate_explained_by_reputation_of_page": "The score is calculated based on the page's reputation compared to those of the SERP"
  },
  "fr": {
    "netlinking_of_my_page": "Netlinking de ma page",
    "rate_explained_by_reputation_of_page": "La note est calculée en fonction de la réputation de la page par rapport à celles de la SERP"
  },
  "de": {
    "netlinking_of_my_page": "Netzverlinkung meiner Seite",
    "rate_explained_by_reputation_of_page": "Die Bewertung wird basierend auf der Reputation der Seite im Vergleich zu denen der SERP berechnet"
  }
}
</i18n>
